<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-80 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h3 class="title">Build student user</h3>
          <h5 class="category">
            This information will let us know more about user.
          </h5>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            About
          </template>
          <first-step ref="step1" @on-validated="firstStep"></first-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">
            Account
          </template>
          <second-step ref="step2" @on-validated="secondStep"></second-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step3')">
          <template slot="label">
            Detail
          </template>
          <third-step ref="step3" @on-validated="thirdStep"></third-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step4')">
          <template slot="label">
            Documents
          </template>
          <fourth-step
            :user_id="userID"
            ref="step4"
            @on-validated="wizardComplete"
          ></fourth-step>
        </wizard-tab>
      </simple-wizard>
      <md-dialog
        :md-click-outside-to-close="false"
        class="loadingPanelDialog"
        :md-active.sync="loadingModal"
        :md-close-on-esc="false"
        :md-fullscreen="false"
      >
        <div class="md-layout loadingPanel">
          <div class="md-layout-item md-size-33">
            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
          </div>
        </div>
      </md-dialog>
    </div>
  </div>
</template>
<script>
import FirstStep from "./UserUpsertSteps/FirstStep.vue";
import SecondStep from "./UserUpsertSteps/SecondStep.vue";
import ThirdStep from "./UserUpsertSteps/ThirdStep.vue";
import FourthStep from "./UserUpsertSteps/FourthStep.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  data() {
    return {
      wizardModel: {},
      loadingModal: false,

      userID: null,
      userInfoID: null,
      // First and second Step data
      first_name: null,
      last_name: null,
      email: null,
      title: null,
      gender: null,
      mobile_phone: null,
      country: null,
      picture: null,
      is_active: false,
      // Third step data
      mother_name: null,
      father_name: null,
      birth_date: null,
      country_of_birth: null,
      nationality: null,
      passport_number: null,
      passport_date_of_expire: null,
      passport_date_of_issue: null,
      country_of_residence: null,
      city_of_residence: null,
      address: null,
      whatsapp_number: null,
      need_visa: false
    };
  },
  components: {
    FourthStep,
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    firstStep(validated, model) {
      if (validated) {
        this.picture = this.$refs["step1"].picture;
        this.first_name = this.$refs["step1"].first_name;
        this.last_name = this.$refs["step1"].last_name;
        this.email = this.$refs["step1"].email;
      }
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    getSecondStepData() {
      this.title = this.$refs["step2"].title;
      this.gender = this.$refs["step2"].gender;
      this.mobile_phone = this.$refs["step2"].mobile_phone;
      this.country = this.$refs["step2"].country;
      this.is_active = this.$refs["step2"].is_active;
    },
    secondStep(validated, model) {
      if (validated) {
        this.getSecondStepData();
      }
      this.wizardModel = { ...this.wizardModel, ...model };
      return validated;
    },
    getThirdStepData() {
      this.mother_name = this.$refs["step3"].mother_name;
      this.father_name = this.$refs["step3"].father_name;
      if (typeof this.$refs["step3"].birth_date === "object") {
        this.birth_date = this.$refs["step3"].birth_date
          .toLocaleDateString("ko-KR")
          .replaceAll(". ", "-")
          .replaceAll(".", "");
      } else {
        this.birth_date = this.$refs["step3"].birth_date;
      }
      this.country_of_birth = this.$refs["step3"].country_of_birth;
      this.nationality = this.$refs["step3"].nationality;
      this.passport_number = this.$refs["step3"].passport_number;
      if (typeof this.$refs["step3"].passport_date_of_expire === "object") {
        this.passport_date_of_expire = this.$refs[
          "step3"
        ].passport_date_of_expire
          .toLocaleDateString("ko-KR")
          .replaceAll(". ", "-")
          .replaceAll(".", "");
      } else {
        this.passport_date_of_expire = this.$refs[
          "step3"
        ].passport_date_of_expire;
      }
      if (typeof this.$refs["step3"].passport_date_of_issue === "object") {
        this.passport_date_of_issue = this.$refs["step3"].passport_date_of_issue
          .toLocaleDateString("ko-KR")
          .replaceAll(". ", "-")
          .replaceAll(".", "");
      } else {
        this.passport_date_of_issue = this.$refs[
          "step3"
        ].passport_date_of_issue;
      }
      this.country_of_residence = this.$refs["step3"].country_of_residence;
      this.city_of_residence = this.$refs["step3"].city_of_residence;
      this.address = this.$refs["step3"].address;
      this.whatsapp_number = this.$refs["step3"].whatsapp_number;
      this.need_visa = this.$refs["step3"].need_visa;
    },
    thirdStep(validated, model) {
      if (validated) {
        this.loadingModal = true;
        this.getThirdStepData();
        // Student User
        let role = 2;
        this.$store
          .upsertBasicUser(
            "POST",
            this.userID,
            {
              first_name: this.first_name,
              last_name: this.last_name,
              email: this.email,
              title: this.title,
              gender: this.gender,
              mobile_phone: this.mobile_phone,
              country: this.country,
              picture: this.picture,
              info: JSON.stringify({
                mother_name: this.mother_name,
                father_name: this.father_name,
                birth_date: this.birth_date,
                country_of_birth: this.country_of_birth,
                nationality: this.nationality,
                passport_number: this.passport_number,
                passport_date_of_expire: this.passport_date_of_expire,
                passport_date_of_issue: this.passport_date_of_issue,
                country_of_residence: this.country_of_residence,
                city_of_residence: this.city_of_residence,
                address: this.address,
                zip_code: this.zip_code,
                whatsapp_number: this.whatsapp_number,
                p_level_education: this.p_level_education,
                p_school_name: this.p_school_name,
                p_program_name: this.p_program_name,
                p_study_language: this.p_study_language,
                p_country: this.p_country,
                p_city: this.p_city,
                is_graduated: this.is_graduated,
                p_graduate_date: this.p_graduate_date,
                have_language_score: this.have_language_score,
                language_exam_name: this.language_exam_name,
                language_exam_date: this.language_exam_date,
                language_score: this.language_score,
                proficiency_test: this.proficiency_test,
                need_visa: this.need_visa
              })
            },
            role
          )
          .then(response => {
            this.loadingModal = false;
            this.userID = response.data.id;
            this.$notify({
              message: "User created.",
              icon: "add_alert",
              type: "success",
              verticalAlign: "top",
              timeout: 3000
            });
          })
          .catch(error => {
            document.getElementsByClassName("prevButton")[0].click();
            this.loadingModal = false;
            var message = error.response.data;
            this.$notify({
              message: JSON.stringify(message),
              icon: "add_alert",
              type: "danger",
              verticalAlign: "top",
              timeout: 5000
            });
          });
      }
      this.wizardModel = { ...this.wizardModel, ...model };
      return validated;
    },
    wizardComplete() {
      Swal.fire({
        title: "Student created.",
        text: "Finish",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$router.push({ name: "Student Users" });
        }
      });
    }
  }
};
</script>

<style lang="css">
.loadingPanel {
  padding: 40px;
  min-width: auto;
}

body > div.md-dialog.loadingPanelDialog > div.md-dialog-container {
  border-radius: 80px !important;
  min-width: 10px;
}
</style>
